import script from "./FormView.vue?vue&type=script&setup=true&lang=js"
export * from "./FormView.vue?vue&type=script&setup=true&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=834277c6&lang=scss"

const __exports__ = script;

export default __exports__